import { useQuery } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

import { SignatureQueryKey } from '../helpers/signature-query-key'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchSignatureByIdOwner(id_owner?: string) {
  const token = useAccessToken()

  return useQuery({
    queryKey: SignatureQueryKey(id_owner),
    queryFn: async () => {
      if (!id_owner) throw new Error('Signature ID_client is required')

      const response = await publicApi.get(`/signatures/owner/${id_owner}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Signature not found')
      }
    },
    enabled: Boolean(token && id_owner)
  })
}
